import {
  PURCHASE_TYPE,
  REFINANCE_TYPE,
  FIFTEEN_YEARS_FIXED,
  THIRTY_YEARS_FIXED,
  FIVE_ONE_ARM,
  TWENTY_YEARS_FIXED,
  TEN_YEARS_FIXED,
  SEVEN_ONE_ARM,
  TEN_ONE_ARM,
} from './constants'

export const propertyTypes = [
  { value: 'singleFamily', label: 'Single family' },
  { value: 'townhouse', label: 'Townhouse' },
  { value: 'condo', label: 'Condo' },
  { value: 'manufacturedHome', label: 'Manufactured home' },
  { value: 'twoUnits', label: '2-unit' },
  { value: 'threeUnits', label: '3-unit' },
  { value: 'fourUnits', label: '4-unit' },
]

export const occupancyTypes = [
  { value: 'primaryResidence', label: 'Primary residence' },
  { value: 'secondHome', label: 'Second home' },
  { value: 'investmentProperty', label: 'Investment property' },
]

export const ficoTypes = [
  { value: 'excellent', label: 'Excellent (740+)' },
  { value: 'veryGood', label: 'Very good (700-739)' },
  { value: 'good', label: 'Good (660-699)' },
  { value: 'fair', label: 'Fair (660 or below)' },
]

export const sortingDropdown = [
  { value: 'monthlyPayment', label: 'Monthly payment' },
  { value: 'apr', label: 'APR' },
  { value: 'fees', label: 'Fees' },
]

export const termsHeaderLabel = {
  [THIRTY_YEARS_FIXED]: '30-year fixed',
  [FIFTEEN_YEARS_FIXED]: '15-year fixed',
  [TWENTY_YEARS_FIXED]: '20-year fixed',
  [TEN_YEARS_FIXED]: '10-year fixed',
  [FIVE_ONE_ARM]: '5/1 adjustable',
  [SEVEN_ONE_ARM]: '7/1 adjustable',
  [TEN_ONE_ARM]: '10/1 adjustable',
}

export const termsHeaderLabelShortVersion = {
  ...termsHeaderLabel,
  [THIRTY_YEARS_FIXED]: '30-yr fixed',
  [FIFTEEN_YEARS_FIXED]: '15-yr fixed',
  [TWENTY_YEARS_FIXED]: '20-yr fixed',
  [TEN_YEARS_FIXED]: '10-yr fixed',
}

export const scoresMap = {
  excellent: '740+',
  veryGood: '700-739',
  good: '660-699',
  fair: '660 or below',
}

export const verticalOptions = [
  { value: PURCHASE_TYPE, label: 'Purchase' },
  { value: REFINANCE_TYPE, label: 'Refinance' },
]
